'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import DynamicLogo from '@components/DynamicLogo';
import DynamicButton from '@components/DynamicButton';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';

import cn from './style.module.scss';

export default function AlGhadeerBanner(props: MarketingPageComponentProps) {
  const bannerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'banner' && section.enabled
  );
  if (!bannerSection) return null;
  const bannerData = bannerSection?.alghadeerBannerData || [];
  const logoData = bannerData.find((item: any) => item.logo);
  const storyData = bannerData.find((item: any) => item.story);
  const taglineData = bannerData.find((item: any) => item.tagline);
  const buttonData = bannerData.find((item: any) => item.alghadeerBannerButton);

  return (
    <Stack component="section" className={cn.alGhadeerBannerWrapper}>
      <Box className={cn.alGhadeerBannerInner}>
        <Box className={cn.alGhadeerBannerBlock}>
          <Box
            className={cn.alGhadeerBannerStory}
            sx={{
              backgroundImage: {
                xs: `url(${storyData?.story?.mobile})`,
                sm: `url(${storyData?.story?.tablet})`,
                md: `url(${storyData?.story?.desktop})`,
              },
            }}
          >
            <Box className={cn.alGhadeerBannerContent}>
              <Box className={cn.alGhadeerContentHeader}>
                <Box className={cn.alGhadeerContentLogo}>
                  <DynamicLogo
                    className={cn.alGhadeerLogoElement}
                    logoImage={logoData?.logo}
                    alt={'AlGhadeer Logo'}
                  />
                </Box>
                <Box className={cn.alGhadeerContentText}>
                  <MobileBreakpoint>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingOne)}
                    </ParallaxText>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingTwo)}
                    </ParallaxText>
                  </MobileBreakpoint>
                  <TabletBreakpoint>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingOne)}
                    </ParallaxText>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingTwo)}
                    </ParallaxText>
                  </TabletBreakpoint>
                  <DesktopBreakpoint>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingOne)}
                    </ParallaxText>
                    <ParallaxText
                      variant="h4"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(taglineData?.tagline?.headingTwo)}
                    </ParallaxText>
                  </DesktopBreakpoint>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={cn.alGhadeerContentButton}>
            <Box className={cn.alGhadeerContentElement}>
              <DynamicButton
                className={cn.alGhadeerContentButton}
                children={buttonData?.alghadeerBannerButton}
                scrollToId="alGhadeerRegistration"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
